export const network = {
  chainId: '0x38', // BSC Mainnet
  chainName: 'BNB Smart Chain',
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18
  },
  rpcUrls: [
    'https://bsc-dataseed.binance.org',
    'https://bsc-dataseed1.binance.org',
    'https://bsc-dataseed2.binance.org'
  ],
  blockExplorerUrls: ['https://bscscan.com']
}
